/**
 * O nome do provedor nas telas da plataforma.
 *
 * O registro guarda a chave e o nome oficial do fornecedor (provider = "vigidata",
 * por exemplo), e isso nao muda. So a area Integracoes mostra o nome oficial; nas
 * demais telas a pessoa le o nome do servico no SeguraCore. A chave gravada continua a
 * mesma: filtros e chamadas a API seguem usando a chave.
 */
const nomesNaPlataforma: Record<string, string> = {
  vigidata: 'SeguraCoreCredit',
  receita_cnpj: 'Receita Federal pela SeguraCoreData',
  brasilapi: 'Receita Federal pela SeguraCoreData',
};

/** O nome de exibicao, ou o nome recebido, ou a propria chave quando nao ha nome. */
export function nomeDoProvedor(chave: string, nome?: string | null): string {
  return nomesNaPlataforma[chave] ?? (nome || chave);
}
